import { createSlice } from "@reduxjs/toolkit";
const NftReducers = createSlice({
	name: "NftReducers",
	initialState: {
		Nft_id: "",
		currentPageState: "",
	},
	reducers: {
		setNFt_ID: (state, action) => {
			state.Nft_id = action.payload;
		},
		clearNFt_ID: (state) => {
			state.Nft_id = "";
		},
		setPagi: (state, action) => {
			state.currentPageState = action.payload;
		},
		clearPagi: (state) => {
			state.currentPageState = "";
		},
	},
});
export const { clearNFt_ID, setNFt_ID, setPagi, clearPagi } =
	NftReducers.actions;
export default NftReducers.reducer;
